import Vue from "vue";

import {
  DatePicker,
  Button,
  Carousel,
  Input,
  FormModel,
  Select,
  Radio,
  Checkbox,
  Breadcrumb,
  Upload,
  Icon,
  Modal,
  Tabs,
  Badge,
  Table,
  Pagination,
  LocaleProvider,
  Message
} from 'ant-design-vue';

Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(FormModel);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Breadcrumb);
Vue.use(Upload);
Vue.use(Icon);
Vue.use(Modal);
Vue.use(Tabs);
Vue.use(Badge);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(LocaleProvider);
Vue.use(Message);
